var Afghanistan = "Afghanistan";
var Albania = "Albania";
var Algeria = "Algeria";
var Andorra = "Andorra";
var Angola = "Angola";
var Anguilla = "Anguilla";
var Antarctica = "Antarctica";
var Argentina = "Argentina";
var Armenia = "Armenia";
var Aruba = "Aruba";
var Australia = "Australia";
var Austria = "Austria";
var Azerbaijan = "Azerbaijan";
var Bahamas = "Bahamas";
var Bahrain = "Bahrain";
var Bangladesh = "Bangladesh";
var Barbados = "Barbados";
var Belarus = "Belarus";
var Belgium = "Belgium";
var Belize = "Belize";
var Benin = "Benin";
var Bermuda = "Bermuda";
var Bhutan = "Bhutan";
var Bolivia = "Bolivia";
var Botswana = "Botswana";
var Brazil = "Brazil";
var Bulgaria = "Bulgaria";
var Burundi = "Burundi";
var Cambodia = "Cambodia";
var Cameroon = "Cameroon";
var Canada = "Canada";
var Chad = "Chad";
var Chile = "Chile";
var China = "China";
var Colombia = "Colombia";
var Comoros = "Comoros";
var Congo = "Congo";
var Croatia = "Croatia";
var Cuba = "Cuba";
var Cyprus = "Cyprus";
var Denmark = "Denmark";
var Djibouti = "Djibouti";
var Dominica = "Dominica";
var Ecuador = "Ecuador";
var Egypt = "Egypt";
var Eritrea = "Eritrea";
var Estonia = "Estonia";
var Ethiopia = "Ethiopia";
var Fiji = "Fiji";
var Finland = "Finland";
var France = "France";
var Gabon = "Gabon";
var Gambia = "Gambia";
var Georgia = "Georgia";
var Germany = "Germany";
var Ghana = "Ghana";
var Gibraltar = "Gibraltar";
var Greece = "Greece";
var Greenland = "Greenland";
var Grenada = "Grenada";
var Guadeloupe = "Guadeloupe";
var Guam = "Guam";
var Guatemala = "Guatemala";
var Guernsey = "Guernsey";
var Guinea = "Guinea";
var Guyana = "Guyana";
var Haiti = "Haiti";
var Honduras = "Honduras";
var Hungary = "Hungary";
var Iceland = "Iceland";
var India = "India";
var Indonesia = "Indonesia";
var Iraq = "Iraq";
var Ireland = "Ireland";
var Israel = "Israel";
var Italy = "Italy";
var Jamaica = "Jamaica";
var Japan = "Japan";
var Jersey = "Jersey";
var Jordan = "Jordan";
var Kazakhstan = "Kazakhstan";
var Kenya = "Kenya";
var Kiribati = "Kiribati";
var Kuwait = "Kuwait";
var Kyrgyzstan = "Kyrgyzstan";
var Latvia = "Latvia";
var Lebanon = "Lebanon";
var Lesotho = "Lesotho";
var Liberia = "Liberia";
var Libya = "Libya";
var Liechtenstein = "Liechtenstein";
var Lithuania = "Lithuania";
var Luxembourg = "Luxembourg";
var Macao = "Macao";
var Madagascar = "Madagascar";
var Malawi = "Malawi";
var Malaysia = "Malaysia";
var Maldives = "Maldives";
var Mali = "Mali";
var Malta = "Malta";
var Martinique = "Martinique";
var Mauritania = "Mauritania";
var Mauritius = "Mauritius";
var Mayotte = "Mayotte";
var Mexico = "Mexico";
var Monaco = "Monaco";
var Mongolia = "Mongolia";
var Montenegro = "Montenegro";
var Montserrat = "Montserrat";
var Morocco = "Morocco";
var Mozambique = "Mozambique";
var Myanmar = "Myanmar";
var Namibia = "Namibia";
var Nauru = "Nauru";
var Nepal = "Nepal";
var Netherlands = "Netherlands";
var Nicaragua = "Nicaragua";
var Niger = "Niger";
var Nigeria = "Nigeria";
var Niue = "Niue";
var Norway = "Norway";
var Oman = "Oman";
var Pakistan = "Pakistan";
var Palau = "Palau";
var Panama = "Panama";
var Paraguay = "Paraguay";
var Peru = "Peru";
var Philippines = "Philippines";
var Pitcairn = "Pitcairn";
var Poland = "Poland";
var Portugal = "Portugal";
var Qatar = "Qatar";
var Romania = "Romania";
var Rwanda = "Rwanda";
var Samoa = "Samoa";
var Senegal = "Senegal";
var Serbia = "Serbia";
var Seychelles = "Seychelles";
var Singapore = "Singapore";
var Slovakia = "Slovakia";
var Slovenia = "Slovenia";
var Somalia = "Somalia";
var Spain = "Spain";
var Sudan = "Sudan";
var Suriname = "Suriname";
var Swaziland = "Swaziland";
var Sweden = "Sweden";
var Switzerland = "Switzerland";
var Taiwan = "Taiwan";
var Tajikistan = "Tajikistan";
var Thailand = "Thailand";
var Togo = "Togo";
var Tokelau = "Tokelau";
var Tonga = "Tonga";
var Tunisia = "Tunisia";
var Turkey = "Türkiye (Turkey)";
var Turkmenistan = "Turkmenistan";
var Tuvalu = "Tuvalu";
var Uganda = "Uganda";
var Ukraine = "Ukraine";
var Uruguay = "Uruguay";
var Uzbekistan = "Uzbekistan";
var Vanuatu = "Vanuatu";
var Venezuela = "Venezuela";
var Yemen = "Yemen";
var Zambia = "Zambia";
var Zimbabwe = "Zimbabwe";
var countries = {
	"Country or region": "Country or region",
	"United States": "United States",
	Afghanistan: Afghanistan,
	"Åland Islands": "Åland Islands",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "American Samoa",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "Antigua and Barbuda",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "Bosnia and Herzegovina",
	Botswana: Botswana,
	"Bouvet Island": "Bouvet Island",
	Brazil: Brazil,
	"British Indian Ocean Territory": "British Indian Ocean Territory",
	"Brunei Darussalam": "Brunei Darussalam",
	Bulgaria: Bulgaria,
	"Burkina Faso": "Burkina Faso",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "Cape Verde",
	"Cayman Islands": "Cayman Islands",
	"Central African Republic": "Central African Republic",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "Christmas Island",
	"Cocos (Keeling) Islands": "Cocos (Keeling) Islands",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "Congo, The Democratic Republic of The",
	"Cook Islands": "Cook Islands",
	"Costa Rica": "Costa Rica",
	"Côte d'Ivoire": "Côte d'Ivoire",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "Czech Republic",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "Dominican Republic",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "El Salvador",
	"Equatorial Guinea": "Equatorial Guinea",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "Falkland Islands (Malvinas)",
	"Faroe Islands": "Faroe Islands",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "French Guiana",
	"French Polynesia": "French Polynesia",
	"French Southern Territories": "French Southern Territories",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "Guinea-Bissau",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "Heard Island and McDonald Islands",
	"Holy See (Vatican City State)": "Holy See (Vatican City State)",
	Honduras: Honduras,
	"Hong Kong": "Hong Kong",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "Iran, Islamic Republic of",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "Isle of Man",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "Korea, Democratic People’s Republic of",
	"Korea, Republic of": "Korea, Republic of",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "Lao People's Democratic Republic",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "Macedonia, The Former Yugoslav Republic of",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "Marshall Islands",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "Micronesia, Federated States of",
	"Moldova, Republic of": "Moldova, Republic of",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "Netherlands Antilles",
	"New Caledonia": "New Caledonia",
	"New Zealand": "New Zealand",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "Norfolk Island",
	"Northern Mariana Islands": "Northern Mariana Islands",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "Palestine, State of",
	Panama: Panama,
	"Papua New Guinea": "Papua New Guinea",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "Puerto Rico",
	Qatar: Qatar,
	"Réunion": "Réunion",
	Romania: Romania,
	"Russian Federation": "Russian Federation",
	Rwanda: Rwanda,
	"Saint Helena": "Saint Helena",
	"Saint Kitts and Nevis": "Saint Kitts and Nevis",
	"Saint Lucia": "Saint Lucia",
	"Saint Pierre and Miquelon": "Saint Pierre and Miquelon",
	"Saint Vincent and The Grenadines": "Saint Vincent and The Grenadines",
	Samoa: Samoa,
	"San Marino": "San Marino",
	"Sao Tome and Principe": "Sao Tome and Principe",
	"Saudi Arabia": "Saudi Arabia",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "Sierra Leone",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "Solomon Islands",
	Somalia: Somalia,
	"South Africa": "South Africa",
	"South Georgia and The South Sandwich Islands": "South Georgia and The South Sandwich Islands",
	Spain: Spain,
	"Sri Lanka": "Sri Lanka",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "Svalbard and Jan Mayen",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "Syrian Arab Republic",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "Tanzania, United Republic of",
	Thailand: Thailand,
	"Timor-Leste": "Timor-Leste",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "Trinidad and Tobago",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "Turks and Caicos Islands",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "United Arab Emirates",
	"United Kingdom": "United Kingdom",
	"United States Minor Outlying Islands": "United States Minor Outlying Islands",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "Viet Nam",
	"Virgin Islands, British": "Virgin Islands, British",
	"Virgin Islands, U.S.": "Virgin Islands, U.S.",
	"Wallis and Futuna": "Wallis and Futuna",
	"Western Sahara": "Western Sahara",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
